export default {
  list(state) {
    return state.sales_manuals;
  },
};
